/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `TransitionType*`'s.
 */
export type TransitionType = TransitionTypeFade | TransitionTypeSlideTopFade;

/**
 * The Transition fade type.
 */
export type TransitionTypeFade = typeof TRANSITION_TYPE_FADE;

/**
 * The Transition slide from top fade type.
 */
export type TransitionTypeSlideTopFade = typeof TRANSITION_TYPE_SLIDE_FROM_TOP_FADE;

/**
 * The Transition fade constant.
 */
export const TRANSITION_TYPE_FADE = `fade`;

/**
 * The Transition slide from top fade constant.
 */
export const TRANSITION_TYPE_SLIDE_FROM_TOP_FADE = `slide-from-top-fade`;
